const constructTeam ={
  path: '/sortMange/constructTeam',
  component: resolve => require(['@/views/sortMange/constructTeam'], resolve),
  name: 'constructTeam',
  meta: {title: '工种类别',keepAlive: false},
};
const constructTeamDetail = {
  path: '/sortMange/constructTeamDetail',
  component: resolve => require(['@/views/sortMange/constructTeamDetail'], resolve),
  name: 'constructTeamDetail',
  meta: {title: '工种类别',keepAlive: false}
};
export default [constructTeam,constructTeamDetail]





// WEBPACK FOOTER //
// ./src/router/modules/sortMange.js